import Component from '@bythepixel/component-loader';

export default class HeaderMenuTabs extends Component {
  static selector = '[comp-menu-tabs-content]'
  static loaderPriority = 'in-view';

  static delay = '300'

  #state = {
    activeSlide: undefined,
  }

  constructor(...args) {
    super(...args);
    this.contentId = this.$container.getAttribute('menu-tabs-content-id');
    this.content = [...this.$container.querySelectorAll('[data-tab-content-index]')].sort(
      (a, b) => Number(a.dataset.tabIndex > b.dataset.tabIndex),
    );
    this.transitionInEnd = this.transitionInEnd.bind(this);
    this.transitionOutEnd = this.transitionOutEnd.bind(this);
    this.noTransitionDelay = this.$container.getAttribute('no-transition-delay');

    this.events();
  }

  events() {
    this.$subscribe(`${this.contentId}:deactivate-tab`, ({ index }) => {
      if (typeof index !== 'number' || !this.content[index]) return;
      this.hideSlide(this.content[index]);
    });

    this.$subscribe(`${this.contentId}:activate-tab`, ({ index }) => {
      if (typeof index !== 'number' || !this.content[index]) return;
      this.showSlide(this.content[index]);
    });

    window.addEventListener('resize', () => {
      requestAnimationFrame(() => this.fixHeight(this.#state.activeSlide));
    });
  }

  fixHeight(tabA) {
    Object.assign(this.$container.style, {
      height: `${tabA.offsetHeight}px`,
    });
  }

  transitionInEnd({ target }) {
    target.classList.remove('absolute');

    if (!this.noTransitionDelay) {
      target.classList.remove('duration-700');
    }

    target.removeEventListener('transitionend', this.transitionInEnd);
  }

  transitionOutEnd({ target }) {
    target.classList.remove('absolute');
    target.classList.add('hidden');
    target.removeEventListener('transitionend', this.transitionOutEnd);
  }

  showSlide(slide) {
    this.#state.activeSlide = slide;
    slide.classList.add('absolute');
    slide.classList.remove('hidden');

    if (!this.noTransitionDelay) {
      slide.classList.add('duration-700');
      setTimeout(() => {
        slide.classList.remove('opacity-0');
      }, HeaderMenuTabs.delay);
    } else {
      slide.classList.remove('opacity-0');
    }

    slide.addEventListener('transitionend', this.transitionInEnd);
    this.fixHeight(slide);
    slide.classList.add('active-tab-content');
  }

  hideSlide(slide) {
    slide.classList.add('absolute');
    slide.addEventListener('transitionend', this.transitionOutEnd);
    slide.classList.add('opacity-0');
    slide.classList.remove('active-tab-content');
  }
}
